function Products(Props){
    return(
        <div className={"productContainer"}>
            {Props.media? <img src={Props.media} alt="gif del producto" className="productDemo"/> : null }
            <div className={"productData"}>
                <a className={"productLinkName"} href={Props.link} target="_blank" rel="noreferrer">{Props.name}</a>
                <p className={"productTech"}>{Props.tech}</p>
                <p className={"productDescription"}>{Props.description}</p>
            </div>

        </div>
    )
}

export default Products;